import instance from '../node_modules/i18next/dist/esm/i18next.js';
import Cookie from '../shared/utils/cookie.js';
import de from './translations/de.json.js';
import en from './translations/en.json.js';
import es from './translations/es.json.js';
import fr from './translations/fr.json.js';
import ja from './translations/ja.json.js';
import pt from './translations/pt.json.js';
import { initReactI18next } from '../node_modules/react-i18next/dist/es/context.js';
import { useTranslation as useTranslation$1 } from '../node_modules/react-i18next/dist/es/useTranslation.js';

var defaultNS = "default";
var resources = {
    de: {
        default: de
    },
    en: {
        default: en
    },
    es: {
        default: es
    },
    fr: {
        default: fr
    },
    ja: {
        default: ja
    },
    pt: {
        default: pt
    }
};
var getLanguage = function () {
    try {
        var language = JSON.parse(Cookie.getCookie("cid_locale") || "{}").language;
        return language;
    }
    catch (_a) {
        return;
    }
};
var i18nInstance = instance.createInstance();
var init = function (_a) {
    var _b = _a === void 0 ? {} : _a, languages = _b.languages;
    var filteredResources = languages
        ? Object.fromEntries(Object.entries(resources).filter(function (_a) {
            var key = _a[0];
            return languages.includes(key);
        }))
        : resources;
    i18nInstance.use(initReactI18next).init({
        lng: getLanguage(),
        ns: [defaultNS],
        defaultNS: defaultNS,
        fallbackLng: "en",
        interpolation: {
            escapeValue: false
        },
        resources: filteredResources
    });
};
var useTranslation = function () { return useTranslation$1(defaultNS, { i18n: i18nInstance }); };
var i18n = {
    init: init,
    i18nInstance: i18nInstance
};

export { i18n as default, defaultNS, resources, useTranslation };
